import clsx from 'clsx'
import React, { useEffect, useState } from 'react'
import style from './style.module.scss'

const unmountTimeoutInSec = 0.5

type selectorDialogProps = React.PropsWithChildren<{
    open: boolean
    onClose: () => void
    className?: string
    keepMounted?: boolean
    closeButtonVariant?: 'text' | 'iconOnly'
}>

export const SelectorDialog: React.FC<selectorDialogProps> = ({
    open,
    onClose,
    children,
    className,
    keepMounted = true,
    closeButtonVariant = 'text',
}) => {
    const [mountedContent, setMountedContent] = useState(keepMounted ? true : open)

    useEffect(() => {
        let timer: NodeJS.Timeout
        if (open) {
            setMountedContent(true)
        } else {
            if (!keepMounted) {
                timer = setTimeout(() => setMountedContent(false), unmountTimeoutInSec * 1000)
            }
        }
        return () => {
            clearTimeout(timer)
        }
    }, [keepMounted, open, setMountedContent])
    // Hide body scrollbar when the dialog is ative
    useEffect(() => {
        if (open) {
            document.body.style.overflow = 'hidden'
        } else {
            document.body.style.overflow = 'visible'
        }
    }, [open])

    return (
        <div
            className={clsx(style.dialog, open ? style.open : undefined, className)}
            style={{ transitionDuration: `${unmountTimeoutInSec}s` }}
        >
            <button
                className={clsx(style.closeButton, style[closeButtonVariant])}
                onClick={onClose}
            >
                <i className="fi fi-rs-cross-small" />
                {closeButtonVariant === 'text' && <span>Fermer</span>}
            </button>

            {mountedContent && children}
        </div>
    )
}
